import "./FigureSenior.module.css";
import Header from "@/reusable_sections/Header";
import TokohSeniorHero from "./sections/TokohSeniorHero";
import CategoryFilterGrid from "./sections/CategoryFilterGrid";
import ZonaPPProfileGrid from "./sections/ZonaPPProfileGrid";
import OrganizationalTrustBar from "./sections/OrganizationalTrustBar";
import Footer from "@/reusable_sections/Footer";
export default function FigureSeniorPage() {
  return <div>
      <Header />
      <TokohSeniorHero />
      <CategoryFilterGrid />
      <ZonaPPProfileGrid />
      <OrganizationalTrustBar />
      <Footer />
    </div>;
}